var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 75 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-10.5,-10.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.78125,0,0,0.78125,10.5,10.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 96,
    height: 96,
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 96,
    height: 96,
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0503,-0.606393,0.606393,1.0503,-39.8683,26.7293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.94,11.97C56.1,21.96 55.95,31.99 56,41.99C57.33,42.22 58.67,42.44 60,42.66C60.01,34.1 59.98,25.52 59.99,16.97C59.98,14.95 60.45,13.19 62.4,12.27C65.07,11.17 67.99,13.05 67.94,15.97C68.11,25.3 67.94,34.66 68,44C69.33,44.22 70.67,44.45 72,44.67C72,38.44 72.01,32.22 71.97,25.99C72.04,23.87 71.87,22.01 73.77,20.62C76.43,18.87 80.01,20.75 79.94,23.97C80.05,41.29 80.03,58.69 79.95,76.01C79.99,82.11 75.14,87.49 69.03,87.87C61.37,88.21 53.67,87.87 46,88.02C42.58,87.97 38.49,88.33 35.43,86.6C33.1,85.42 31.38,83.22 29.76,81.22C25.21,75.44 20.4,69.86 15.88,64.06C13.65,61.31 14.41,57.25 17.09,55.11C19.72,52.98 23.3,52.9 25.93,55.1C29.4,57.91 32.6,61.07 35.99,63.99C35.99,48.66 36.03,33.33 35.97,17.99C36.04,15.87 35.87,14.01 37.77,12.62C40.43,10.87 44.01,12.75 43.94,15.97C44.11,23.97 43.94,32 44,40.01C45.33,40.23 46.67,40.44 48,40.66C48.01,31.44 47.99,22.18 47.99,12.97C47.98,10.95 48.45,9.19 50.4,8.27C53.07,7.17 55.99,9.05 55.94,11.97Z",
    style: {
      fillRule: "nonzero"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.28d57726c81acf1bb9c21d5a56d0ce73.svg";
export { ForwardRef as ReactComponent };